import { RawAxiosRequestHeaders } from 'axios';

export function getBearerHeader(token: string): RawAxiosRequestHeaders {
  return { Authorization: `Bearer ${token}` };
}

export function getBasicHeader(token: string): RawAxiosRequestHeaders {
  return { Authorization: `Basic ${token}` };
}
